import {
	Box,
	Checkbox,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";

import { sortAmount, sortBoolean, sortDate } from "../../../utils/sort-methods";

import Body2 from "../../typography/body-02";

import styles from "./index.module.scss";

import "./mui-styles.scss";

const TableHeadLoanDocuments = (props) => {
	const {
		data,
		// sort
		order,
		orderBy,
		onRequestSort,
		rowData,
		setSortedData,
		// select
		selectedCount,
		rowCount,
		onSelectAllClick,
	} = props;

	const createSortHandler = (property) => (event) => {
		let fieldId;

		console.log("40 property:", property);

		if (property === "label") {
			fieldId = "entityName";
		} else if (property === "upload-date") {
			fieldId = "createdDate";
		} else if (property === "current-version") {
			fieldId = "isActive";
		}

		console.log("40 fieldId:", fieldId);

		let sortedData;

		if (property.includes("date")) {
			sortedData = sortDate(rowData, order, fieldId);
		} else if (property === "current-version") {
			sortedData = sortBoolean(rowData, order, fieldId);
		} else {
			sortedData = sortAmount(rowData, order, fieldId);
		}

		console.log("40 sortedData:", sortedData);

		setSortedData(sortedData);
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow
				sx={{
					"& th": {
						py: 0.15
					}
				}}
			>
				<TableCell padding="checkbox"
					sx={{
						pl: 4,
					}}
				>
					<Checkbox
						className={styles.checkboxContainer}
						indeterminate={selectedCount > 0 && selectedCount < rowCount}
						checked={rowCount > 0 && selectedCount === rowCount}
						onChange={onSelectAllClick}
						inputProps={{
							"aria-label": "select all desserts",
						}}
					/>
				</TableCell>
				{data.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
						style={{ minWidth: headCell.minWidth }}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
						>
							<Body2
								text={headCell.label}
								extraClass={styles.thText}
								fontType="semibold"
							/>
							{orderBy === headCell.id ? (
								<Box component="span" sx={visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
};

export default TableHeadLoanDocuments;
